import { action } from "@ember/object"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import { findRotationDate } from "cc-frontend/utils/filter-dates/rotation-calendar"
import styles from "./body.module.css"

interface ChangeRotationBodyArgs {
  rotationCalendar: RotationCalendar
  rotationCycleResetsOnDay: boolean
  dateString: string
}

export default class ChangeRotationBodyComponent extends Component<ChangeRotationBodyArgs> {
  readonly styles = styles
  @tracked _selectedRotationId = null

  get selectedRotationId() {
    if (this._selectedRotationId !== null) {
      return this._selectedRotationId
    } else {
      let date = findRotationDate(this.args.rotationCalendar, this.args.dateString)
      return date?.attributes.rotationId
    }
  }

  @action selectRotation(rotationId) {
    this._selectedRotationId = rotationId
  }
}
